import { render, staticRenderFns } from "./WorkTodo.vue?vue&type=template&id=227be7d4&scoped=true"
import script from "./WorkTodo.vue?vue&type=script&lang=js"
export * from "./WorkTodo.vue?vue&type=script&lang=js"
import style0 from "./WorkTodo.vue?vue&type=style&index=0&id=227be7d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227be7d4",
  null
  
)

export default component.exports